import script from "./save-or-reject.vue?vue&type=script&setup=true&lang=js"
export * from "./save-or-reject.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__